import React from 'react'
import PropTypes from 'prop-types'

import styles from './index.css'

export default function (props) {
  return (
    <div className={styles.ManageButton} {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
          <g fill="none" fillRule="evenodd">
              <path d="M-2-2h20v20H-2z"/>
              <path fill="#34ADFA" d="M13.845 0l-9.16 9.16-.268 2.423 2.422-.267L16 2.155 13.845 0zM0 2.286V16h13.714V5.518L7.381 11.85a.766.766 0 0 1-.458.22L4.5 12.34a.763.763 0 0 1-.84-.845l.268-2.423a.759.759 0 0 1 .22-.452l6.328-6.333H0z"/>
          </g>
      </svg>
      Edit 
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/buttons/EditButton/index.jsx